export enum State {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  NEW_DOCUMENTS_REQUESTED = 'new_documents_requested',
}

export enum VerificationMethod {
  EXTERNAL_VERIFIER = 'external_verifier',
  SIGNED_LETTER = 'signed_letter',
  SUPPORTING_DOCUMENTS = 'supporting_documents',
}

export type Verification506cRequest = {
  id: number;
  state: State;
  reminderEmailNote?: string;
  verificationMethod?: VerificationMethod;
};
